define(
    'widgets/fp_form_addfdocuments/viewmodel',[
        'durandal/app',
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (app, dataProvider, i19n) {

        ko.utils.stringContains = function(string, contains) {
            string = string || "";
            return string.toLowerCase().indexOf(contains.toLowerCase()) >= 0;
        };

        var ctor = function () { };

        ctor.prototype.activate = function (settings) {
            var self = this;
            
            self.i19n = i19n;
            self.settings = settings;

            self.exceptList = [];
            self.fid = '';
            self.title = ko.observable();
            self.$wnd = null;
            self.wnd = null;
            self.resultCount = ko.observable();
            
            self.searchText = ko.observable('');
            self.clearSelected = function () {
                self.documentsList().forEach(function(itm) {
                    itm.isSelected(false);
                });
            };
            self.addSelectedDocuments = function () {
                var selected = _(self.documentsList()).filter(function (d) {
                    return d.isSelected() == true;
                });

                if (selected.length > 0) {
                    selected = $.map(selected, function (itm) {
                        return itm.id;
                    });

                    self.settings.data.addDocuments(selected);

                    self.wnd.close();
                }
            };
            self.selectDocument = function (data) {
                data.isSelected(!data.isSelected());
            };
            self.documentsList = ko.observableArray([]);
            self.documentsFiltered = ko.computed(function () {
                self.clearSelected();

                return ko.utils.arrayFilter(self.documentsList(), function(r) {
                    return (                        
                        ko.utils.stringContains(r.title.toLowerCase(), self.searchText().toLowerCase()) ||
                        ko.utils.stringContains(r.title.toLowerCase(), self.searchText().toLowerCase())
                        );
                });
            });
            self.isDocumentsEmpty = ko.observable(true);
            self.refresh = function () {
                dataProvider
                    .templatedocuments
                    .getFlaggedDocuments()
                    .done(function (data) {
                        var ids = {};
                        _.each(self.exceptList, function (d) {
                            ids[d.id] = true;
                        });

                        data = _.filter(data.data, function (d) {
                            return !ids[d.documentId];
                        }, self.exceptList);

                        data = _.sortBy(data, function (d) {
                            return d.title.toLowerCase();
                        });

                        data = $.map(data, function (itm) {
                            return { id: itm.documentId, title: itm.title, isSelected: ko.observable(false) };
                        });

                        self.documentsList(data);

                        self.isDocumentsEmpty(data.length == 0);
                    })
                    .fail(function () {
                        console.log('error getting documents');
                    });
            };

            settings.data.show = function () {
                initialize(self);

                self.title(self.settings.data.title);
                self.fid = self.settings.data.fid;
                self.exceptList = self.settings.data.exceptList;

                self.refresh();

                self.wnd.title("Add to " + self.settings.data.title);
                self.wnd.center().open();
            };
        };

        ctor.prototype.attached = function () {
            var self = this;            

            self.$wnd = $("#widget-addfdocuments-form");

            if (self.wnd == null) {
                self.wnd = self.$wnd
                    .kendoWindow({
                        title: '',//self.settings.data.windowtitle,
                        modal: true,
                        visible: false,
                        resizable: false,
                        width: 650,
                        height: 350,
                        close: closeAddDocumentsForm
                    }).data("kendoWindow");                
            }

            function closeAddDocumentsForm(data) {
            };
        };

        function initialize(self) {
            self.documentsList([]);
            self.searchText('');
        }

        return ctor;
    });
